import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

const getTitleFromPath = (pathname) => {
  const titles = {
    "/": "หน้าหลัก",

    // รายงาน
    "/reports": "รายงาน",
    "/sales-report": "รายงานขาย",
    "/inventory-movement-report": "รายงานเคลื่อนไหวสินค้า",
    "/stock-balance-report": "รายงานสินค้าคงคลัง",
    "/loan-crate-report": "รายงานตะกร้าสินเชื่อ",
    "/deposit-report": "รายงานเงินมัดจำ",
    "/overdue-loan-crate-report": "รายงานสินเชื่อเกินกำหนด",
    "/receivables-report": "รายงานลูกหนี้",
    "/payables-report": "รายงานเจ้าหนี้",
    "/vansale-report": "รายงาน Vansale",

    // จัดซื้อสินค้า
    "/purchase": "จัดซื้อสินค้า",
    "/deposit-document": "ใบมัดจำ",
    "/purchase-request": "ใบขอซื้อ",
    "/purchase-order": "ใบสั่งซื้อ",
    "/product-receipt": "ใบรับสินค้า",
    "/payment-voucher": "ใบสำคัญจ่าย",

    // คลังสินค้า
    "/warehouse": "คลังสินค้า",
    "/warehouse-stock": "สต็อกคลังสินค้า",
    "/treasury-documents": "จัดการเอกสารคลัง",

    // ใบยืม-ใบเบิก
    "/borrow-withdrawal": "ใบยืม-ใบเบิก",
    "/bill-of-lading": "ใบเบิก Vansale",
    "/icebox": "ใบยืมสินค้า",
    "/technical-equip-form": "ใบเบิกอุปกรณ์ช่าง",
    "/office-equip-form": "ใบเบิกวัสดุใช้ภายใน",

    // ขายสินค้า
    "/sellproducts": "ขายสินค้า",
    "/quotation": "ใบเสนอราคา (QT)",
    "/order-product": "ออเดอร์สินค้า (OD)",
    "/billofsale": "ใบขาย (SO)",
    "/picking-list": "Picking List (PK)",

    // งานบัญชี
    "/account": "งานบัญชี",
    "/payment-stock": "ตรวจสอบค้างจ่าย",
    "/bill": "ใบวางบิล (BI)",
    "/invoice": "ใบกำกับภาษี (INV)",
    "/tax": "หนังสือหัก ณ ที่จ่าย",

    // ข้อมูลตั้งต้น
    "/initialdata": "ข้อมูลตั้งต้น",
    "/creditor": "ข้อมูลเจ้าหนี้",
    "/APtype": "ข้อมูลประเภทเจ้าหนี้",
    "/debtor": "ข้อมูลลูกหนี้",
    "/ARtype": "ข้อมูลประเภทลูกหนี้",
    "/company": "ข้อมูลบริษัท",
    "/dept": "ข้อมูลแผนก",
    "/position": "ข้อมูลตำแหน่ง",
    "/employee": "ข้อมูลพนักงาน",
    "/car": "ข้อมูลรถ",
    "/transType": "ข้อมูลวิธีการขนส่ง",
    "/docType": "ข้อมูลประเภทเอกสาร",
    "/tbsetitem": "ข้อมูลสินค้า",
    "/brand": "ข้อมูลแบรนด์สินค้า",
    "/tb-set-unit": "ข้อมูลหน่วยสินค้า",
    "/tb-set-wh": "ข้อมูลคลังสินค้า",

    // Login / 404
    "/login": "เข้าสู่ระบบ",
  };

  return titles[pathname] || "PBPOS";
};

const PageTitleSetter = () => {
  const { pathname } = useLocation();
  const title = getTitleFromPath(pathname);

  return (
    <Helmet>
      <title>PBPOS | {title}</title>
    </Helmet>
  );
};

export default PageTitleSetter;
